

















































import {Vue, Component, Watch} from "vue-property-decorator";
import BulletPoints from "@/views/components/BulletPoints.vue";
import HowItWorks from "@/views/components/onboarding/pages/HowItWorks.vue";
import {namespace} from "vuex-class";
import {Languages} from "@/constants/locale";
const userDataModule = namespace("userData");
const hubsModule = namespace("hubs");

@Component({
  name: "Onboarding",
  components: {
    BulletPoints,
    HowItWorks,
  },
})
export default class Onboarding extends Vue {
  private step: number = 1;
  private numSteps: number = 4;

  @userDataModule.Getter("getLanguage")
  private getLanguage!: Languages;

  @hubsModule.Getter("existsOnlyOneHub")
  private existsOnlyOneHub!: boolean;

  // we should not use a watch as this value is not to be changed
  // the correct flow would be to initialize this on load
  // but whatever, it will work :)
  @Watch("existsOnlyOneHub")
  private updateHubsIfOnlyOne() {
    if (this.existsOnlyOneHub) {
      this.numSteps = 3;
    }
  }

  get isSpanish(): boolean {
    return this.getLanguage === Languages.es;
  }

  get isCatalan(): boolean {
    return this.getLanguage === Languages.ca;
  }

  private created() {
    this.$uiBus.on("intro:step", this.goToStep);
    this.$uiBus.on("intro:next", this.next);
    this.updateHubsIfOnlyOne();
  }

  private destroyed() {
    this.$uiBus.off("intro:step", this.goToStep);
    this.$uiBus.off("intro:next", this.next);
  }

  private goToStep(n: number) {
    this.step = n;
  }

  private next() {
    if (this.step < this.numSteps) {
      this.goToStep(this.step + 1);
    } else {
      this.$emit("onboarding:finish");
    }
  }

}
